<div class="header-label">{{ serviceAddress?.displayName }}</div>
<div class="flex-fill d-flex flex-column">
  <div class="flex-fill content-block dx-card p-3">
    @if (serviceAddress) {
      <dx-form [formData]="serviceAddress" class="col-sm-6" style="max-width: 500px" [readOnly]="true">
        <dxi-form-item itemType="group" caption="Site Information">
          <dxi-form-item dataField="customer.displayName" [label]="{ text: 'Customer' }"></dxi-form-item>
          <dxi-form-item dataField="customer.type.name" [label]="{ text: 'Type' }"></dxi-form-item>
          <dxi-form-item dataField="displayAddress" [label]="{ text: 'Site Address' }"></dxi-form-item>
        </dxi-form-item>
      </dx-form>
    }
    @if (jobs) {
      <div class="flex-fill">
        <dx-data-grid
          #jobGrid
          keyExpr="id"
          class="h-100"
          [dataSource]="jobs"
          [showBorders]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          >
          <dxi-data-grid-column dataField="id" caption="Job #" width="100"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="rental.customer.displayName" caption="Customer" width="225"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="jobType.name" caption="Job Type" width="150"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="driver.displayName" caption="Driver" width="150"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="dumpster.size" caption="Dumpster" width="75"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="weight" width="100"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="startDate" dataType="date" format="M/d/yyyy" width="150"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="endDate" dataType="date" format="M/d/yyyy" width="150"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="completed" dataType="date" format="M/d/yyyy" width="150"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="driverNotes" caption="Notes"></dxi-data-grid-column>
          <div *dxTemplate="let data of 'gridTitle'">
            <h4>Jobs</h4>
          </div>
          <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
          <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
          <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
          <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
        </dx-data-grid>
      </div>
    }
  </div>
</div>
